export const ourStrengthData = [
  {
    count: '2k +',
    label: 'Total Users',
    desc: 'EscapePlan serves a diverse clientele of over 200 users',
  },
  {
    count: '50 +',
    label: 'Auto CAD Techinicians',
    desc: 'EscapePlan has a network of 50+ skilled AutoCAD technicians.',
  },
  {
    count: '2M +',
    label: 'Satisfied Clients',
    desc: 'With a 2M + satisfaction rate, we provide exceptional service.',
  },
  {
    count: '1000 +',
    label: 'Templates and Symbols',
    desc: 'Escapeplan offers over 1000 templates and symbols for your drawing needs.',
  },
  {
    count: '3k +',
    label: 'Successful Projects',
    desc: 'Escape Plan has completed 3k+ projects, with regular reviews from both professionals and clients',
  },
];
